import { useTranslation } from 'react-i18next'
import { connect, useDataItem } from 'scrivito'

import { ActivityTab } from '../SharedTabs/ActivityTab/ActivityTab'
import { ContactTab } from '../SharedTabs/ContactTab/ContactTab'
import { DocumentTab } from '../SharedTabs/DocumentTab/DocumentTab'
import { MessageTab } from '../SharedTabs/MessageTab/MessageTab'
import { NavTabs, NavTabItem } from '@/Atomic/Templates/NavTabs'
import { NavTab } from '@/Atomic/Widgets/DataItemTabs/const'
import { ActivityProjectRelation } from '@/Data/ActivityProjectRelation/ActivityProjectRelationDataClass'
import { DataClassName } from '@/Data/const'
import { ContactProjectRelation } from '@/Data/ContactProjectRelation/ContactProjectRelationDataClass'
import { DocumentProjectRelation } from '@/Data/DocumentProjectRelation/DocumentProjectRelationDataClass'
import { Message } from '@/Data/Message/MessageDataClass'
import { useFeatureFlagAccess } from '@/utils/featureFlagConfig'

const ALL_NAV_TABS: NavTab[] = [
  NavTab.ACTIVITY,
  NavTab.CONTACT,
  NavTab.MESSAGE,
  NavTab.DOCUMENT,
]

export const OpportunityDataItemTabs: React.FC = connect(() => {
  const { t } = useTranslation()
  const { filterTabs } = useFeatureFlagAccess()
  const dataItem = useDataItem()
  const dataItemId = dataItem?.id() ?? ''

  if (!dataItemId) return

  const visibleNavTabs = filterTabs(ALL_NAV_TABS)
  const isVisible = (tab: NavTab) => visibleNavTabs.includes(tab)

  const activityCount = isVisible(NavTab.ACTIVITY)
    ? (ActivityProjectRelation.all()
        .transform({ filters: { project: dataItemId } })
        .count() ?? 0)
    : 0

  const contactCount = isVisible(NavTab.CONTACT)
    ? (ContactProjectRelation.all()
        .transform({ filters: { project: dataItemId } })
        .count() ?? 0)
    : 0

  const messageCount = isVisible(NavTab.MESSAGE)
    ? (Message.all()
        .transform({ filters: { subjectId: dataItemId } })
        .count() ?? 0)
    : 0

  const documentCount = isVisible(NavTab.DOCUMENT)
    ? (DocumentProjectRelation.all()
        .transform({ filters: { project: dataItemId } })
        .count() ?? 0)
    : 0

  const tabsByNavTab: Array<{ navTab: NavTab; tab: NavTabItem }> = [
    {
      navTab: NavTab.ACTIVITY,
      tab: {
        id: 'activities',
        title: t('pages.activities.title'),
        icon: 'activity',
        count: activityCount,
        content: (
          <ActivityTab
            searchInputName="search opportunity-activity"
            activityRelation="project"
          />
        ),
      },
    },
    {
      navTab: NavTab.CONTACT,
      tab: {
        id: 'contacts',
        title: t('components.contact.title'),
        icon: 'user-multiple',
        count: contactCount,
        content: (
          <ContactTab
            searchInputName="search opportunity-contact"
            contactRelation="project"
          />
        ),
      },
    },
    {
      navTab: NavTab.MESSAGE,
      tab: {
        id: 'messages',
        title: t('components.message.title'),
        icon: 'note',
        count: messageCount,
        content: <MessageTab />,
      },
    },
    {
      navTab: NavTab.DOCUMENT,
      tab: {
        id: 'documents',
        title: t('components.document.documents'),
        icon: 'file-empty',
        count: documentCount,
        content: (
          <DocumentTab relationTo={DataClassName.DOCUMENT_PROJECT_RELATION} />
        ),
      },
    },
  ]

  const tabs: NavTabItem[] = tabsByNavTab
    .filter((entry) => isVisible(entry.navTab))
    .map((entry) => entry.tab)

  if (!tabs.length) return

  return <NavTabs tabs={tabs} />
})
